import React from 'react';

const TextArea = ({name,placeholder,id, errors, value, handleChange}) => {

    return (
        <div>
            <label className="mb-0 mt-2">{placeholder}</label>
            <div className="input-group wow fadeInUp mt-2" data-wow-delay="1.8s">
                <textarea
                    name={name}
                    id={id}
                    value={value}
                    className="form-control"
                    placeholder={placeholder}
                    onChange={handleChange}
                    rows="4"
                >
                </textarea>
                <div
                    id={`${id}-error`}
                    className="invalid-feedback animated fadeInUp p-0"
                    style={{ display: "block" }}
                >
                    {errors && errors}
                </div>
            </div>
        </div>

    )

}

export default TextArea



